// Define qué datos necesita tu librería para funcionar
export interface LibConfig {
  apiUrl: string;
  mapsApiKey: string;
  apiFilesUrl: string;
  apiHl: string;
}

import { InjectionToken } from '@angular/core';

// Creamos el token único para toda la configuración
export const LIB_CONFIG = new InjectionToken<LibConfig>('shared_lib.config');

